import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import naive from 'naive-ui'

// 导入 highlight.js
import hljs from 'highlight.js/lib/core'
import json from 'highlight.js/lib/languages/json'
import javascript from 'highlight.js/lib/languages/javascript'
import 'highlight.js/styles/github.css'

// 注册语言
hljs.registerLanguage('json', json)
hljs.registerLanguage('javascript', javascript)

// 导入全局样式
import './assets/styles.css'
import './styles/mobile.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(naive)

// 全局配置 hljs
app.config.globalProperties.$hljs = hljs

app.mount('#app') 